/*
 * JM floater lift
 * ---------------
 * Discount tabs, chat bubbles and cookie widgets park themselves at the bottom
 * of the viewport and land on top of our sticky bars. This finds the ones that
 * actually collide with a given bar and lifts them clear while it is showing.
 *
 * Three things make that harder than it sounds:
 *
 * 1. Shopify Forms (the "5% off" teaser) and several other apps render inside a
 *    SHADOW ROOT, so document.querySelectorAll('*') never sees them. We walk
 *    shadow roots as well.
 * 2. Those apps ship their CSS as adoptedStyleSheets on that shadow root, which
 *    cascade after anything we could inject into it. So the lift is written as
 *    an inline !important declaration, which outranks both, composed on top of
 *    whatever transform the widget already had so we do not move it sideways.
 * 3. Do NOT touch the widget's transition property. On the Shopify Forms teaser,
 *    writing `transition` restarts the app's own transform handling and our
 *    translate is discarded -- tested, it silently does nothing. The lift is
 *    therefore instant, which is also what you want when the bar slides in.
 *
 * Usage: var lifter = window.JMFloaterLift(barElement);
 *        lifter.lift();  // returns the count of widgets it could not move
 *        lifter.drop();
 */
(function () {
  if (window.JMFloaterLift) return;

  var SKIP = '#PBarNextFrameWrapper';

  function allRoots() {
    var list = [document];
    function walk(root) {
      var nodes = root.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var sr = nodes[i].shadowRoot;
        if (sr && list.indexOf(sr) === -1) {
          list.push(sr);
          walk(sr);
        }
      }
    }
    try { walk(document); } catch (e) {}
    return list;
  }

  window.JMFloaterLift = function (bar) {
    var records = [];
    var observers = [];

    function find() {
      var found = [];
      var box = bar.getBoundingClientRect();
      if (!box.height || box.top >= window.innerHeight) return found;

      allRoots().forEach(function (root) {
        var nodes;
        try { nodes = root.querySelectorAll('*'); } catch (e) { return; }
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          if (el === bar) continue;
          if (bar.contains(el) || el.contains(bar)) continue;
          if (el.closest && el.closest(SKIP)) continue;

          var cs;
          try { cs = window.getComputedStyle(el); } catch (e) { continue; }
          if (!cs || cs.position !== 'fixed') continue;
          if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue;

          var r = el.getBoundingClientRect();
          if (r.width < 8 || r.height < 8) continue;
          /* Full-width overlays and modals are not bottom-parked widgets. */
          if (r.width > window.innerWidth * 0.92) continue;
          /* No vertical overlap with the bar: nothing to do. */
          if (r.bottom <= box.top + 2 || r.top >= box.bottom - 2) continue;

          var nested = false;
          for (var j = 0; j < found.length; j++) {
            if (found[j].el.contains && found[j].el.contains(el)) { nested = true; break; }
          }
          if (!nested) found.push({ el: el, root: root, base: cs.transform });
        }
      });
      return found;
    }

    function recordFor(el) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].el === el) return records[i];
      }
      return null;
    }

    function watch(root) {
      if (!window.MutationObserver) return;
      for (var i = 0; i < observers.length; i++) {
        if (observers[i].root === root) return;
      }
      var pending = null;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = window.setTimeout(function () { pending = null; lift(); }, 400);
      });
      try {
        mo.observe(root === document ? document.body : root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style']
        });
        observers.push({ root: root, mo: mo });
      } catch (e) {}
    }

    function lift() {
      var by = bar.offsetHeight + 12;
      var want = 'translateY(-' + by + 'px)';
      var stuck = 0;
      var touched = [];

      find().forEach(function (hit) {
        var el = hit.el;
        var rec = recordFor(el);

        if (!rec) {
          rec = {
            el: el,
            /* Whatever transform the widget positions itself with, if any. */
            base: hit.base && hit.base !== 'none' ? hit.base : '',
            inlineTransform: el.style ? el.style.transform : ''
          };
          records.push(rec);
        } else if (el.style && el.style.getPropertyValue('transform').indexOf(want) !== -1) {
          /* Already lifted by the right amount. */
          return;
        }

        try {
          el.style.setProperty('transform', (rec.base ? rec.base + ' ' : '') + want, 'important');
          if (el.style.getPropertyValue('transform').indexOf(want) === -1) stuck++;
        } catch (e) { stuck++; }

        if (touched.indexOf(hit.root) === -1) touched.push(hit.root);
      });

      /* Apps re-render their widgets and rewrite their own style attribute. */
      touched.forEach(watch);

      return stuck;
    }

    function drop() {
      records.forEach(function (rec) {
        try {
          rec.el.style.removeProperty('transform');
          if (rec.inlineTransform) rec.el.style.transform = rec.inlineTransform;
        } catch (e) {}
      });
      observers.forEach(function (entry) { entry.mo.disconnect(); });
      records = [];
      observers = [];
    }

    return { lift: lift, drop: drop };
  };
})();
